module.exports = __webpack_public_path__ + "img/Group 241.9050a680.svg";